module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-geo-65-medium.76cc9337.ttf";